import React from 'react'
import { Card, Typography, Tag, Space } from 'antd'
import {
  CheckCircleFilled,
  LockOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons'

const { Text } = Typography

interface PhaseCardProps {
  stato: string
  label: string
  color: string
  ordine: number
  currentOrder: number
  children?: React.ReactNode
  extra?: React.ReactNode
}

const PhaseCard: React.FC<PhaseCardProps> = ({
  label,
  color,
  ordine,
  currentOrder,
  children,
  extra,
}) => {
  const isCompleted = currentOrder > ordine
  const isCurrent = currentOrder === ordine
  const isLocked = currentOrder < ordine

  const borderColor = isLocked ? '#d9d9d9' : color

  const statusBadge = isCompleted ? (
    <CheckCircleFilled style={{ color: '#52c41a', fontSize: 16 }} />
  ) : isCurrent ? (
    <Tag color={color} style={{ fontWeight: 600, borderRadius: 12 }}>
      In corso
    </Tag>
  ) : (
    <LockOutlined style={{ color: '#bfbfbf' }} />
  )

  return (
    <Card
      style={{
        marginBottom: 16,
        borderLeft: `4px solid ${borderColor}`,
        opacity: isLocked ? 0.65 : 1,
        transition: 'opacity 0.2s',
      }}
      styles={{
        header: {
          borderBottom: isLocked ? 'none' : undefined,
        },
      }}
      title={
        <Space>
          <Text
            strong
            style={{
              color: isLocked ? '#bfbfbf' : color,
              fontSize: 15,
            }}
          >
            Fase {ordine}: {label}
          </Text>
          {statusBadge}
        </Space>
      }
      extra={!isLocked ? extra : undefined}
    >
      {isLocked ? (
        <Space style={{ color: '#bfbfbf' }}>
          <InfoCircleOutlined />
          <Text type="secondary">
            Fase non ancora disponibile — completa le fasi precedenti per sbloccare questa sezione
          </Text>
        </Space>
      ) : (
        children
      )}
    </Card>
  )
}

export default PhaseCard
